/* eslint-disable @typescript-eslint/no-explicit-any */
import IndeterminateCheckbox from 'components/base/IndeterminateCheckbox';
import { PropsWithChildren } from 'react';
import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  ColumnDef,
  InitialTableState
} from '@tanstack/react-table';
interface UseAdvanceTableProps<T> {
  columns: ColumnDef<T>[];
  data: T[];
  selection?: boolean;
  sortable?: boolean;
  pagination?: boolean;
  pageSize?: number;
  selectionColumnWidth?: number | string;
  initialState?: InitialTableState;
  hasFooter?: boolean;
  tableOptions?: any;
}

const selectionColumn = {
  id: 'select',
  accessorKey: '',
  header: ({ table }: any) => {
    const rows = table.getRowModel().rows;
    const rowData = rows.map((row: any) => row.original);
    const checkSelect = rowData.filter(
      (row: any) => row?.is_remove_table_selected_all
    ).length;

    if (checkSelect) {
      return null;
    }

    return (
      <IndeterminateCheckbox
        className="form-check fs-8 mb-0"
        {...{
          checked: table.getIsAllRowsSelected(),
          indeterminate: table.getIsSomeRowsSelected(),
          onChange: table.getToggleAllRowsSelectedHandler()
        }}
      />
    );
  },
  cell: ({ row }: any) => {
    if (row.original.is_remove_table_selected) {
      return null;
    }
    return (
      <IndeterminateCheckbox
        className="form-check fs-8 mb-0"
        {...{
          checked: row.getIsSelected(),
          disabled: !row.getCanSelect(),
          indeterminate: row.getIsSomeSelected(),
          onChange: row.getToggleSelectedHandler()
        }}
      />
    );
  },
  meta: {
    headerProps: { style: { width: '30px' } }
  }
};

const useAdvanceTable = <T,>({
  columns,
  data,
  selection,
  sortable,
  pagination,
  pageSize,
  initialState,
  hasFooter = false,
  tableOptions = {}
}: PropsWithChildren<UseAdvanceTableProps<T>>) => {
  const state = {
    pagination: { pageSize: pagination ? pageSize : data?.length },
    ...initialState
  };
  const table = useReactTable<T>({
    data,
    columns: selection ? [selectionColumn, ...columns] : columns,
    enableSorting: sortable,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    initialState: state,
    enableRowSelection: selection,
    ...tableOptions
  });

  table.options.meta = {
    ...table.options.meta,
    hasFooter
  };

  return table;
};

export default useAdvanceTable;
